export const songs = [
  { url: "https://www.youtube.com/watch?v=PJXi5zRX7OQ", title: "Tuta Pull Wahan" },
  { url: "https://www.youtube.com/watch?v=asIpemC_RKo", title: "Teri Hogaiyaan" },
  { url: "https://www.youtube.com/watch?v=79Yc9gN3TPM", title: "Aaoge Tum Kabhi" },
  { url: "https://www.youtube.com/watch?v=_65_c-0ubCw", title: "Hona Tha Pyar" },
  { url: "https://www.youtube.com/watch?v=wYcY4j-drvk", title: "Bohot Bechain" },
  { url: "https://www.youtube.com/watch?v=GdLHO0X24eI", title: "KHALI SALAM DUA" },
  { url: "https://www.youtube.com/watch?v=41aFReksDAI", title: "tere bina" },
  { url: "https://www.youtube.com/watch?v=5LMqtzgXaRQ", title: "I GUESS I'M IN LOVE" },
  { url: "https://www.youtube.com/watch?v=Ngr_oT-KTVs", title: "Mere Gaon Aaoge" },
  { url: "https://www.youtube.com/watch?v=6MnicJnDcJg", title: "Tu Aisa Kaise Hai (feat. Sanchi)" },
  { url: "https://www.youtube.com/watch?v=9C7FGC-ibY4", title: "Until I Found You" },
  { url: "https://www.youtube.com/watch?v=5uBlLI1a_lA", title: "Aao Chalein" },
  { url: "https://www.youtube.com/watch?v=nR-z8cKtueE", title: "Kaise Ho Tum" },
  { url: "https://www.youtube.com/watch?v=bO7VIsz2g44", title: "SABSE PEECHE HUM KHADE" },
  { url: "https://www.youtube.com/watch?v=7ptMorGrTFk", title: "Aahatein (Unplugged)" },
  { url: "https://www.youtube.com/watch?v=RcP5gMAOZuU", title: "Aaya Mausam" },
  { url: "https://www.youtube.com/watch?v=MOSvsisv-9E", title: "Aise Kaise" },
  { url: "https://www.youtube.com/watch?v=bkmeQfvSmYg", title: "Aise Kyun (Ghazal Version)" },
  { url: "https://www.youtube.com/watch?v=yLXPQOchSJg", title: "Pahadon Mein" },
  { url: "https://www.youtube.com/watch?v=S4_G1o91T9I", title: "Sahiba (From \"Phillauri\")" },
  { url: "https://www.youtube.com/watch?v=wJfex3METxs", title: "Phir Le Aya Dil" },
  { url: "https://www.youtube.com/watch?v=f419vqAt8PU", title: "Ishq (From \"Lost;Found\")" },
  { url: "https://www.youtube.com/watch?v=23PqQ9vSUVM", title: "Awaargi" },
  { url: "https://www.youtube.com/watch?v=QtaVtGfprLY", title: "Tu Hi Das" },
  { url: "https://www.youtube.com/watch?v=w6Vj7fq1LEQ", title: "Kaafizyada" },
  { url: "https://www.youtube.com/watch?v=0OlUATnvYwk", title: "Saibo (Lofi Flip)" },
  { url: "https://www.youtube.com/watch?v=CyoUiKewD1Q", title: "Tu Hoti Toh" },
  { url: "https://www.youtube.com/watch?v=_7NFYwMovRQ", title: "Shaayad" },
  { url: "https://www.youtube.com/watch?v=Ic-bX0tIZUA", title: "Sun Lo Na" },
  { url: "https://www.youtube.com/watch?v=XwgtqxyE1Hw", title: "City Life" },
  { url: "https://www.youtube.com/watch?v=vXzsjtJBNXk", title: "Dil Pukare" },
  { url: "https://www.youtube.com/watch?v=uL9FdKp2QHc", title: "Faasley" },
  { url: "https://www.youtube.com/watch?v=c_AOw99Xd8E", title: "Yahan Koi Nahi" },
  { url: "https://www.youtube.com/watch?v=-rObfAcJlpg", title: "Mann" },
  { url: "https://www.youtube.com/watch?v=tNVjKl-Yfmk", title: "Kitse" },
  { url: "https://www.youtube.com/watch?v=Xi_diGiuyIw", title: "Akela Hoon" },
  { url: "https://www.youtube.com/watch?v=3VnrjwOExaM", title: "Khaare Raste" },
  { url: "https://www.youtube.com/watch?v=oQN2fHcoBVE", title: "Kaari" },
  { url: "https://www.youtube.com/watch?v=fh4656U6RtY", title: "Kachha Ghada" },
  { url: "https://www.youtube.com/watch?v=dtLyZnW-F6g", title: "Saajna (Unplugged)" },
  { url: "https://www.youtube.com/watch?v=yTr_ajmS84g", title: "Ghar" },
  { url: "https://www.youtube.com/watch?v=ROd2n5IVOHk", title: "Shaayar" },
  { url: "https://www.youtube.com/watch?v=l5-8G7jqmqg", title: "Bye" },
  { url: "https://www.youtube.com/watch?v=3PxZcZzZY1M", title: "Dil Nachda" },
  { url: "https://www.youtube.com/watch?v=ZS9LCKloE4M", title: "Milon Chala" },
  { url: "https://www.youtube.com/watch?v=7bvXq7OacRM", title: "Akhiyaan" },
  { url: "https://www.youtube.com/watch?v=mlHS2VaP49k", title: "Mere Hi Liye" },
  { url: "https://www.youtube.com/watch?v=R1lxJ39jA-E", title: "Laapata" },
  { url: "https://www.youtube.com/watch?v=5ZrhIVLPVIo", title: "Chaand" },
  { url: "https://www.youtube.com/watch?v=ea8DxHuQnh4", title: "Ye Dil" },
  { url: "https://www.youtube.com/watch?v=Yy2KVv31BCA", title: "Glimpse of Us" },
  { url: "https://www.youtube.com/watch?v=6p4Mt6MHZYQ", title: "Take Me Home (Pahadon Mein)" },
  { url: "https://www.youtube.com/watch?v=cBM402rUsHg", title: "Teri Kami (Feat. Jstsid)" },
  { url: "https://www.youtube.com/watch?v=zP9n2ZAS28Q", title: "Faasle" },
  { url: "https://www.youtube.com/watch?v=fZZFKVbQpoE", title: "Chor" },
  { url: "https://www.youtube.com/watch?v=y5_Bu-0b_io", title: "Tumhare Aane Se" },
  { url: "https://www.youtube.com/watch?v=WEVioOjZE8k", title: "Chale Sabse Dur" },
  { url: "https://www.youtube.com/watch?v=tZHxcwyg0G0", title: "Aa Mil" },
  { url: "https://www.youtube.com/watch?v=oupTzTbvJiI", title: "Shimla Tha Ghar" },
  { url: "https://www.youtube.com/watch?v=2tUifWi7mhs", title: "Tu Nasha" },
  { url: "https://www.youtube.com/watch?v=_l4hwXNZHgo", title: "Aik parinda tha" },
  { url: "https://www.youtube.com/watch?v=F_u9i6QSwGc", title: "Kya Maine Socha" },
  { url: "https://www.youtube.com/watch?v=FlrWM2cCWPA", title: "Tu Hai Kahan" },
  { url: "https://www.youtube.com/watch?v=Pn0oz35zngM", title: "Chaadar" },
  { url: "https://www.youtube.com/watch?v=kL2UG7bNoGA", title: "Jaane De" },
  { url: "https://www.youtube.com/watch?v=-ApnKUXLAmE", title: "Jogi" },
  { url: "https://www.youtube.com/watch?v=zYcGjV05y10", title: "Tera Hi Rahun" },
  { url: "https://www.youtube.com/watch?v=3IFiM6DCJ4o", title: "Tum" },
  { url: "https://www.youtube.com/watch?v=3C6mx8eebn0", title: "Mann Kasturi" },
  { url: "https://www.youtube.com/watch?v=Pg-MyL7DaFo", title: "Faasle" },
  { url: "https://www.youtube.com/watch?v=uiaGeHli4e4", title: "Teri Meri Pehli Sham" },
  { url: "https://www.youtube.com/watch?v=wDFY5w-pRWY", title: "Sumjhe Nahin" },
  { url: "https://www.youtube.com/watch?v=IAIQWjHxkbg", title: "Sajna Door (From \"Teefa In Trouble\")" },
  { url: "https://www.youtube.com/watch?v=tm5rtRuR9rs", title: "Saiyyan" },
  { url: "https://www.youtube.com/watch?v=ELfKIDYHoYs", title: "Wafaaein" },
  { url: "https://www.youtube.com/watch?v=CkZMHQCjCI0", title: "Bhulado (Album Version)" },
  { url: "https://www.youtube.com/watch?v=0r6xNNcvkOc", title: "Tu Zaroori Hai - 1 Min Music" },
  { url: "https://www.youtube.com/watch?v=JpH57lWRCD8", title: "Anokhi Si Ladki" },
  { url: "https://www.youtube.com/watch?v=EFAJcxnFLgs", title: "nadaaniyan" },
  { url: "https://www.youtube.com/watch?v=oxIwIf7lqzE", title: "Make You Mine" },
  { url: "https://www.youtube.com/watch?v=j7AvmW0V_hI", title: "Kabhie Phool Dena (Pyar Ke Naam) (Rules - Pyar Ka Super Hit Formula / Soundtrack Version)" },
  { url: "https://www.youtube.com/watch?v=YiRISbb0lQQ", title: "Akela Rasta" },
  { url: "https://www.youtube.com/watch?v=HmRBjDJ2FBQ", title: "Shor" },
  { url: "https://www.youtube.com/watch?v=Hkxv2po4QWM", title: "Khataa" },
  { url: "https://www.youtube.com/watch?v=vHW4dLbMjiM", title: "Tasawur" },
  { url: "https://www.youtube.com/watch?v=MqEPQGcSeYk", title: "Aahatein" },
];
